'use client';

import { useTranslations } from 'next-intl';
import { ProductSetItemValue } from '@headless-workspace/domain/common/server';
import { GlowTextBody, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ProductSetItem } from './ProductSetItem';

export type ProductSetListProps = PropsWithFontFamily & {
    productsList?: ProductSetItemValue[];
    isVipBrand: boolean;
    priceAlwaysBlack: boolean;
    squaredShade: boolean;
    enableDiscountInfo: boolean;
};

export const ProductSetList: Component<ProductSetListProps> = ({
    productsList,
    fontFamily,
    isVipBrand,
    priceAlwaysBlack,
    enableDiscountInfo,
}) => {
    const t = useTranslations('Discover.Pdp.information.selector');

    if (!productsList?.length) {
        return null;
    }
    return (
        <div>
            <GlowTextBody className={'pb-0.75'} fontWeight={'bold'} text={t('label.productSetContains')} />
            <div className={'flex flex-col gap-[3.5rem]'}>
                {productsList.map((item, index) => (
                    <ProductSetItem
                        key={index}
                        fontFamily={fontFamily}
                        isVipBrand={isVipBrand}
                        priceAlwaysBlack={priceAlwaysBlack}
                        squaredShade={false}
                        index={index}
                        currency={item.currency}
                        formats={item.formats}
                        name={item.name}
                        brand={item.brand}
                        variants={item.variants}
                        type={item.type}
                        enableDiscountInfo={enableDiscountInfo}
                    />
                ))}
            </div>
        </div>
    );
};
